import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../ErrorFallback";

const ErrorBoundaryComponent = ({ children }) => (
  <ErrorBoundary FallbackComponent={ErrorFallback} onReset={() => {}}>
    {children}
  </ErrorBoundary>
);

export default ErrorBoundaryComponent;
